import { IEasyfyEvent, IDataMapper, IEasyfyEventExporter } from '@shared/easyfy.events/easyfy.eventdata';

/* Ga4 Exporter class */
export class Ga4EventExporter implements IEasyfyEventExporter {
  mapper: IDataMapper;
  WithMapper(mapper: IDataMapper): void {
    this.mapper = mapper;
  }

  RegisterEvent(event: IEasyfyEvent): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (!this.mapper) return;
      var eventData = this.mapper.MapEventData(event);
      await this.PushToDataLayer(eventData);
      resolve();
    })
  }

  async PushToDataLayer(ga4Event: any): Promise<any> {
    return new Promise<void>(async (resolve) => {
      if (ga4Event) {
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({ ecommerce: null });
        if (Array.isArray(ga4Event)) {
          window['dataLayer'].push(...ga4Event);
        } else {
          window['dataLayer'].push(ga4Event);
        }
      }
      resolve();
    })

    //console.group('%c GA DataLayer ', 'color: #bada55');
    //console.dir(window['dataLayer']);
    //console.groupEnd();
  }
}